// Notificaciones globales (snackbar) — useNotify().success("...") / .error("...")
import React, { createContext, useCallback, useContext, useMemo, useState } from "react";
import PropTypes from "prop-types";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";

const NotificationContext = createContext(null);

export function NotificationProvider({ children }) {
  const [snack, setSnack] = useState(null);

  const notify = useCallback((message, severity = "info") => {
    setSnack({ message, severity, key: Date.now() });
  }, []);

  const api = useMemo(
    () => ({
      success: (msg) => notify(msg, "success"),
      error: (msg) => notify(msg, "error"),
      info: (msg) => notify(msg, "info"),
      warning: (msg) => notify(msg, "warning"),
    }),
    [notify]
  );

  return (
    <NotificationContext.Provider value={api}>
      {children}
      <Snackbar
        key={snack?.key}
        open={Boolean(snack)}
        autoHideDuration={4000}
        onClose={() => setSnack(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        {snack ? (
          <Alert
            onClose={() => setSnack(null)}
            severity={snack.severity}
            variant="filled"
            sx={{ width: "100%", borderRadius: 2, fontWeight: 500 }}
          >
            {snack.message}
          </Alert>
        ) : undefined}
      </Snackbar>
    </NotificationContext.Provider>
  );
}

NotificationProvider.propTypes = {
  children: PropTypes.node,
};

export function useNotify() {
  const ctx = useContext(NotificationContext);
  if (!ctx) {
    return {
      success: () => {},
      error: () => {},
      info: () => {},
      warning: () => {},
    };
  }
  return ctx;
}
